import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  icon: {
    width: spacing(14),
    marginRight: spacing(6),
  },
}))
